import { createContext, useContext } from "react";

/**
 * One-shot signal carrying the assistant message id to replay from the recovery
 * affordance (the producer) to the `chat-model-adapter` (the consumer). The
 * affordance sets it immediately before calling `aui.thread().startRun(...)`;
 * the adapter reads it at the top of `run()` and clears it, so a later
 * composer-sent turn is never silently routed to the retry endpoint.
 *
 * A React context rather than a module-level ref, for the same reason as
 * `RefineContext`: it scopes the signal to one `RuntimeProvider`, so two chat
 * surfaces on the same page cannot cross-contaminate each other's retries.
 */
export interface RetryContextValue {
    setRetryTargetMessageId: (messageId: number | undefined) => void;
}

export const RetryContext = createContext<RetryContextValue | undefined>(
    undefined
);

/** Undefined outside a RuntimeProvider, so callers can degrade rather than throw. */
export function useRetryTarget(): RetryContextValue | undefined {
    return useContext(RetryContext);
}
